import React, {useEffect, useRef,useState } from "react"; 
import { getEnvUrl,getToken } from "../../../utils/Api"; 
import CreateEditSubject from "./popups/createSubject";
import ViewSubject from  "./popups/viewSubject"
import Loader from "../../common/loader";
import { toast } from 'react-toastify';
import { deleteSubjectByID } from "../../../Services/Subjects/SubjectServices";
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
const $ = require("jquery");
require("datatables.net");
const Subject = ({ data }) => {
  const tableRef = useRef(null); 
  const [isLoading, setIsLoading] = useState(true);
  const [subjectModal, setSubjectModal] = useState(false);
  const [viewSubjectModal, setViewSubjectModal] = useState(false);
  const [editSubjectModal, seteditSubjectModal] = useState(false);  
  const [viewSubjectId, setViewSubjectId] = useState(false);
  const [editSubjectId, setEditSubjectId] = useState(false);
  const [rerender, setRetender] = useState(true);
  const navigate = useNavigate();
  const createPopupClose=(rr=true)=>{
    setSubjectModal(false)
    if(rr){
      setRetender(!rerender)
    } 
  }
  let viewSubjectModalClose=()=>{
    setViewSubjectModal(false)
  }
  const editSubjectModalClose=(rr=true)=>{
    seteditSubjectModal(false)
    if(rr){
      setRetender(!rerender)
    } 
  }
  useEffect(() => {
    if(!checkPermissions('subject_page') || !checkPermissions('games_navigation')){ 
      navigate('/')
    }
  },[])
 
  useEffect(() => {
    // Initialize DataTable
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",
      ajax: {
        url: `${getEnvUrl()}/admin/subject/getSubjectsList`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      },
      columns: [
        { data: "id" },
        { data: "name" },
        { data: "active" },
        { 
          data: null,
          title: 'Actions',
          render:  (data, type, row) => (
            `<div> 
            <span class="a-edit"><i class="bi bi-pencil-square"></i></span>
            <span class="a-view"><i class="bi bi-eye-fill"></i></span>
            <span class="a-delete"><i class="bi bi-trash-fill"></i></span>
            </div>`
          )
            }
      ],
      'columnDefs': [ {
        'targets': [3], /* column index */
        'orderable': false, /* true or false */
     }],
     createdRow: (row, data, dataIndex) => {  
      if(!checkPermissions('subject_edit')){
        $(row).find('.a-edit').remove();
      }
      if(!checkPermissions('subject_view')){
        $(row).find('.a-view').remove();
      }
      if(!checkPermissions('subject_delete')){
        $(row).find('.a-delete').remove();
      }

      $(row).find('.a-edit').on('click', () => {seteditSubjectModal(true)
                  setEditSubjectId(data.id)
} );   
      $(row).find('.a-view').on('click', () => { setViewSubjectModal(true)
                  setViewSubjectId(data.id)

      } );        
      $(row).find('.a-delete').on('click', () => { 
      if(window.confirm('Are you sure you want to delete this subject?')){
          deleteSubjectByID(data.id)
          .then((response) => {
         if (response.status===true) {
            toast.success(response.message)
            setRetender(!rerender)
         }else{
          toast.error(response.errorMessage)
         }
         })
         .catch((error) => {
         toast.error('Error deleting subject:', error);
         });
        }
       } );
    },
     drawCallback: function(settings) {
      setIsLoading(false);
    },
      aaSorting: [[0, "desc"]],
    });

    return () => {
      // Destroy DataTable when component unmounts to avoid memory leaks
      table.destroy();
    };
  }, [data,rerender]);

  
  return (
    <div>
    <main id="main" className="main">
       <div className="pagetitle">
          <h1>Subject</h1>
       </div>
       <section className="section">
          <div className="row">
             <div className="col-lg-12">
                <div className="card p-10">
                  {checkPermissions("subject_create") && 
                      <h5 className="card-title">
                      <button
                        type="button"
                        className="btn btn-primary float-right"                        
                        onClick={()=>{setSubjectModal(true)}}
                        >
                        + Add subject
                        </button>
                      </h5>}
                      {isLoading?
                      <Loader />
                      :"" }
                      <div className={isLoading?'card-body hide':'card-body'}>
                      <table
                         className="table table-striped table-hover table-bordered no-footer dataTable"
                         width="100%"
                         ref={tableRef}
                         >
                         <thead>
                            <tr>
                               <th>Subject id</th>
                               <th>Name</th>
                               <th>Active</th>
                               <th>Action</th>
                            </tr>
                         </thead>
                      </table>
                   </div>
                </div>
          </div>
 </div>
 </section>
 </main> 
 {subjectModal?<CreateEditSubject isShow={subjectModal} close={createPopupClose} type="CREATE"/>:''}  
 {viewSubjectModal?<ViewSubject isShow={viewSubjectModal} subjectId={viewSubjectId} close={viewSubjectModalClose}  />:''} 
 {editSubjectModal?<CreateEditSubject isShow={editSubjectModal} close={editSubjectModalClose} subjectId={editSubjectId} type="EDIT"/>:''} 
 
 </div>
  );
};

export default Subject;